import { useState } from "react";
import "./SearchBar.css";

export default function SearchBar({ onSearch, onLocate }) {
  const [city, setCity] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    if (city.trim()) {
      onSearch(city.trim());
    } else {
      alert("Please enter a city");
    }
  }

  return (
    <form className="search-form" onSubmit={handleSubmit}>
      <input
        type="text"
        className="search-input"
        placeholder="Enter a city..."
        value={city}
        onChange={(e) => setCity(e.target.value)}
      />
      <button type="submit" className="btn btn-search">
        Search
      </button>
      <button type="button" className="btn btn-locate" onClick={onLocate}>
        📍 My Location
      </button>
    </form>
  );
}
